/**
 * Gilded Veil PDP — sync top price + Save badge with Buy More Save More pack selection.
 * Compare-at = unit MSRP ₱499 × qty (₱499 / ₱998 / ₱1,497). Never sale×qty (₱498/₱747).
 * Sale packs stay ₱249 / ₱449 / ₱649 from pack button final prices.
 */
(function () {
  var UNIT = null; // { sale, compare } in cents
  var DEFAULT_COMPARE_CENTS = 49900; // ₱499 MSRP

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function isGildedPage() {
    var b = document.body;
    var d = document.documentElement;
    return (
      (b && (
        b.classList.contains('template-product-gilded_01') ||
        b.classList.contains('template-product-gilded-veil') ||
        b.classList.contains('template-product-gilded_luxe')
      )) ||
      (d && (
        d.classList.contains('template-product-gilded_01') ||
        d.classList.contains('template-product-gilded-veil') ||
        d.classList.contains('template-product-gilded_luxe')
      )) ||
      /view=gilded/i.test(location.search || '')
    );
  }

  function parseMoney(text) {
    if (text == null) return null;
    var n = String(text).replace(/[^\d.]/g, '');
    if (!n) return null;
    return Math.round(parseFloat(n) * 100);
  }

  function formatPeso(cents) {
    var v = (Math.max(0, cents) / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₱' + parts.join('.');
  }

  function priceRoots() {
    var list = [];
    document
      .querySelectorAll(
        '.product__info-container .price, .product__info-wrapper .price, [id^="price-template"] .price, [id^="price-"] .price'
      )
      .forEach(function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    if (!list.length) {
      var fallback = document.querySelector('.product__info-container .price, .price.lumin-price');
      if (fallback) list.push(fallback);
    }
    return list;
  }

  function captureUnitPrices() {
    if (UNIT) return UNIT;
    var root = priceRoots()[0];
    var sale = null;
    var compare = null;
    if (root) {
      var saleEl =
        root.querySelector('.price__sale .price-item--sale') ||
        root.querySelector('.price-item--sale') ||
        root.querySelector('.price-item--last');
      var compareEl =
        root.querySelector('.price__sale s.price-item--regular') ||
        root.querySelector('s.price-item--regular');
      sale = parseMoney(saleEl && saleEl.textContent);
      compare = parseMoney(compareEl && compareEl.textContent);
    }
    if (!sale) sale = 24900;
    // Never fall back to sale (that produced ₱498 / ₱747). Use ₱499 MSRP.
    if (!compare || compare <= sale) compare = DEFAULT_COMPARE_CENTS;
    UNIT = { sale: sale, compare: compare };
    return UNIT;
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text;
  }

  function updateBadge(root, pct) {
    var badge =
      root.querySelector('.price__badge-sale strong') ||
      root.querySelector('.lm-badge.price__badge-sale strong') ||
      root.querySelector('.lm-badge strong') ||
      root.querySelector('.badge.price__badge-sale strong');
    if (!badge) {
      var wrap =
        root.querySelector('.price__badge-sale') ||
        root.querySelector('.lm-badge.price__badge-sale') ||
        root.querySelector('.lm-badge.badge');
      if (wrap) {
        badge = wrap.querySelector('strong');
        if (!badge) {
          badge = document.createElement('strong');
          wrap.appendChild(badge);
        }
      }
    }
    if (!badge) return;
    badge.textContent = pct > 0 ? 'Save ' + pct + '%' : 'Save 0%';
    var parent = badge.closest('.price__badge-sale, .lm-badge, .badge');
    if (parent) parent.style.display = '';
  }

  function applyPrices(finalCents, compareCents) {
    var pesosFinal = formatPeso(finalCents);
    var pesosCompare = formatPeso(compareCents);
    var pct = 0;
    if (compareCents > finalCents) {
      pct = Math.round(((compareCents - finalCents) / compareCents) * 100);
    }

    priceRoots().forEach(function (root) {
      setText(root.querySelector('.price__sale .price-item--sale') || root.querySelector('.price-item--sale'), pesosFinal);
      setText(root.querySelector('.price__sale s.price-item--regular') || root.querySelector('s.price-item--regular'), pesosCompare);
      setText(root.querySelector('.price__regular .price-item--regular'), pesosFinal);
      root.classList.toggle('price--on-sale', compareCents > finalCents);
      updateBadge(root, pct);
    });

    document
      .querySelectorAll(
        '.sticky-atc .price-item--sale, .sticky-atc-price .price-item--sale, .sticky-bar .price-item--sale, product-sticky-atc .price-item--sale'
      )
      .forEach(function (el) {
        el.textContent = pesosFinal;
      });
    document
      .querySelectorAll(
        '.sticky-atc s.price-item--regular, .sticky-atc-price s.price-item--regular, .sticky-bar s.price-item--regular'
      )
      .forEach(function (el) {
        el.textContent = pesosCompare;
      });
  }

  /** Force pack-card strikethrough to MSRP×qty so ₱498/₱747 never remain. */
  function fixPackComparePrices() {
    var units = captureUnitPrices();
    if (!units) return;
    document.querySelectorAll('.tiered-quantity-options .tiered-option').forEach(function (btn) {
      var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 0;
      if (!qty) return;
      var text = formatPeso(units.compare * qty);
      btn.querySelectorAll('.tiered-option__compare-price, [class*="compare-price"]').forEach(function (el) {
        el.textContent = text;
      });
    });
  }

  function readPackButton(btn) {
    if (!btn) return null;
    var units = captureUnitPrices();
    if (!units) return null;
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    var finalEl =
      btn.querySelector('.tiered-option__final-price') ||
      btn.querySelector('[class*="final-price"]');
    var finalCents = parseMoney(finalEl && finalEl.textContent);
    if (finalCents == null) finalCents = units.sale * qty;

    // Always MSRP × qty
    var compareCents = units.compare * qty;
    if (compareCents < finalCents) compareCents = DEFAULT_COMPARE_CENTS * qty;

    return { finalCents: finalCents, compareCents: compareCents, qty: qty };
  }

  function syncFromButton(btn) {
    var data = readPackButton(btn);
    if (!data) return;
    fixPackComparePrices();
    applyPrices(data.finalCents, data.compareCents);
  }

  function activePackButton() {
    return (
      document.querySelector('.tiered-quantity-options .tiered-option--active') ||
      document.querySelector('.tiered-quantity-options .tiered-option.tiered-option--active') ||
      document.querySelector('.tiered-quantity-options .tiered-option[aria-pressed="true"]') ||
      document.querySelector('.tiered-quantity-options .tiered-option')
    );
  }

  function bind() {
    if (!isGildedPage()) return;
    captureUnitPrices();
    fixPackComparePrices();
    var active = activePackButton();
    if (active) syncFromButton(active);
  }

  onReady(function () {
    if (!isGildedPage()) return;
    bind();

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest && e.target.closest('.tiered-quantity-options .tiered-option');
        if (!btn) return;
        setTimeout(function () {
          syncFromButton(btn);
        }, 0);
      },
      true
    );

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.id || t.id.indexOf('Quantity-') !== 0) return;
      var qty = parseInt(t.value, 10);
      if (!qty) return;
      var btn = document.querySelector('.tiered-quantity-options .tiered-option[data-quantity="' + qty + '"]');
      if (btn) syncFromButton(btn);
    });

    document.addEventListener('shopify:section:load', bind);
    setTimeout(bind, 400);
    setTimeout(bind, 1200);
  });
})();
